import { API_BASE } from "../config";
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import Loader from "../components/Loader";
import Swal from "sweetalert2";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const CheckAuth = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("admin-mobile-token");

    if (!token) {
      setLoading(false);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return;
    }

    const fetchUser = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userData = res?.data?.user || res?.data || null;

        if (!userData) {
          throw new Error("User data not returned");
        }

        setUser({
          id: userData.id,
          name: userData.name || "Admin",
          email: userData.email || "",
          role: userData.role || "ADMIN",
          type: "sewa",
        });
      } catch (error) {
        console.error("Auth check error:", error);
        localStorage.removeItem("admin-mobile-token");

        if (window.location.pathname !== "/login") {
          Swal.fire({
            icon: "error",
            title: "Authentication Failed",
            text: "Please log in again.",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/login";
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) return <Loader />;

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default CheckAuth;
